// 在使用gio时，全局使用window.gio，目前无法通过ES Module使用

// GrowingIO 2.0
// https://docs.growingio.com/v3/developer-manual/sdkintegrated/web-js-sdk/latest-jssdk
/* eslint-disable */
!(function (e, t, n, g, i) {
  ;(e[i] =
    e[i] ||
    function () {
      ;(e[i].q = e[i].q || []).push(arguments)
    }),
    (n = t.createElement('script')),
    (tag = t.getElementsByTagName('script')[0]),
    (n.async = 1),
    (n.src =
      (document.location.protocol == 'https:' ? 'https://' : 'http://') + g),
    tag.parentNode.insertBefore(n, tag)
})(window, document, 'script', 'assets.giocdn.com/2.1/gio.js', 'gio')

if(window.gio) {
  window.gio('init', 'afe8e95ef63d7230', {})
  window.gio('config', { hashtag: true })
  window.gio('send')
}